import React, { useEffect, useState } from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";

export default function CheckBoxComp({
  data,
  selectedFilterValues,
  setSelectedFilterValues,
  setIsAll,
}) {
  console.log(data);

  const allOptionsData =
    Object.values(data ?? {})[0]?.map((value) =>
      value === null ? "NULL" : value === "" ? "BLANK" : value
    ) ?? [];

  console.log(allOptionsData);

  // allOptionsData =

  const [searchTerm, setSearchTerm] = useState("");
  const handleCheckboxChange = (value) => {
    let localArray = [];
    if (selectedFilterValues.includes(value)) {
      localArray = selectedFilterValues.filter((item) => item !== value);
    } else {
      localArray = [...selectedFilterValues, value];
    }
    setSelectedFilterValues(localArray);
  };

  const handleSelectAllToggle = () => {
    if (selectedFilterValues.length === allOptionsData.length) {
      console.log("isAll is unChecked");
      setSelectedFilterValues([]);
    } else {
      console.log("isAll is Checked");
      setSelectedFilterValues(allOptionsData);
    }
  };

  const isAllSelected = selectedFilterValues.length === allOptionsData.length;
  useEffect(() => {
    console.log(isAllSelected);
    if (setIsAll) {
      setIsAll(isAllSelected);
    }
  }, [isAllSelected]);

  if (Array.isArray(allOptionsData)) {
    allOptionsData.forEach((item) => {});
  } else {
    console.log("Data is not an array");
  }

  const filteredOptions = allOptionsData.filter((option) => {
    if (typeof option === "string") {
      return option.toLowerCase().includes(searchTerm.toLowerCase());
    } else if (typeof option === "number") {
      return option.toString().toLowerCase().includes(searchTerm.toLowerCase());
    }
  });
  console.log(filteredOptions);

  return (
    <>
      <main className="h-auto flex flex-col items-center justify-start gap-2 w-full ">
        <section className="flex flex-col items-center justify-center gap-2 w-full ">
          <div className="flex items-center justify-center w-[104%] relative -left-[8px]">
            <FaMagnifyingGlass className="relative left-6 text-gray-400" />
            <input
              type="text"
              placeholder="Search..."
              className="border rounded border-gray-200 pl-8 pr-2 py-1 w-[100%] select-custom focus:outline-none"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <button className="flex items-center justify-start text-left w-full relative left-[2px]">
            <input
              type="checkbox"
              id="select-all-checkbox"
              checked={isAllSelected}
              onChange={handleSelectAllToggle}
              className="mr-[6px] checkbox-input"
            />
            <label htmlFor="select-all-checkbox" className="cursor-pointer">
              Select All
            </label>
          </button>
        </section>
        <section
          className={`overflow-auto py-1 px-1 border w-full rounded ${
            filteredOptions.length <= 4 ? "h-auto" : "h-32"
          }`}
        >
          {filteredOptions.map((option, index) => (
            <button
              key={index}
              className="flex items-center mb-1"
              onChange={() => handleCheckboxChange(option)}
            >
              <input
                type="checkbox"
                id={`checkbox-${index}`}
                value={option}
                checked={selectedFilterValues.includes(option)}
                className="mr-[6px] checkbox-input"
              />
              <label
                htmlFor={`checkbox-${index}`}
                className="truncate hover:text-[#5ac189] cursor-pointer"
              >
                {option}
              </label>
            </button>
          ))}
        </section>
      </main>
    </>
  );
}
